import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const WeekendPolicyListApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    getWeekendPolicy: builder.query({
      query: () => ({url: API_ENDPOINTS.WEEKENDPOLICY.GET_WEEKENDPOLICY()}),
      providesTags: ["WeekendPolicy"],
    }),

    // post
    addWeekendPolicy: builder.mutation({
      query: ({ data }) => ({
          url: API_ENDPOINTS.WEEKENDPOLICY.ADD_WEEKENDPOLICY(),
          method: "POST",
          body: data,
        }),
         invalidatesTags: ["WeekendPolicy"],
    }),

    // put
    updateWeekendPolicy: builder.mutation({
      query: ({ data, yearMonth }) => ({
          url: API_ENDPOINTS.WEEKENDPOLICY.UPDATE_WEEKENDPOLICY(yearMonth),
          method: "PUT",
          body: data,
        }),
        invalidatesTags: ["WeekendPolicy"],
    }),

  }),
});

export const { useGetWeekendPolicyQuery, useAddWeekendPolicyMutation, useUpdateWeekendPolicyMutation } = WeekendPolicyListApi;
